import { forwardRef, TextareaHTMLAttributes } from 'react';

import { cn } from './cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, invalid, ...props }, ref) => (
  <textarea
    ref={ref}
    aria-invalid={invalid || undefined}
    className={cn(
      'flex min-h-24 w-full resize-y rounded-auditor border border-line-strong bg-surface px-3 py-2 text-sm text-ink',
      'placeholder:text-ink-subtle focus-visible:border-brand focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand/20',
      'disabled:cursor-not-allowed disabled:bg-canvas disabled:opacity-60',
      'aria-[invalid=true]:border-critical aria-[invalid=true]:ring-critical/20',
      className,
    )}
    {...props}
  />
));

Textarea.displayName = 'Textarea';
